module.exports = __webpack_public_path__ + "static/coworking4-9ad6c7658ca3e13260341f9651d77241.jpg";